import React from 'react';

import {
  Grid,
  Button,
} from '@material-ui/core';

import InputField from '../../common/components/inputField';

import classes from '../../css/getCSS';


const searchNameForm = (props) => {
  const buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Search
    </Button>
  );

  return (
    <React.Fragment>
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="first_name"
            config={props.inputs.first_name}
            changed={event => props.inputChangedHandler(event, 'first_name')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="last_name"
            config={props.inputs.last_name}
            changed={event => props.inputChangedHandler(event, 'last_name')}
          />
        </Grid>
      </Grid>
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default searchNameForm;



// WEBPACK FOOTER //
// ./src/search/components/SearchNameForm.js